import { h } from 'preact'
import { signal } from '@preact/signals'
import { useLayoutEffect } from 'preact/hooks'
import { setAllToMaxHeight } from '../../js/modules/setAllToMaxHeight.js'
import { isMobile } from '../../js/modules/utilities.js'

export const musicState = signal('')

export const Music = (props) => {
   const { title, cacheKey, item_portrait, items_landscape } = props
   let autopromo = ''
   if (musicState.value !== '' && musicState.value['autopromo'] !== undefined) {
      autopromo = musicState.value['autopromo']
   }

   useLayoutEffect(() => {
      setAllToMaxHeight('.js-musique-thumb')
   })

   return (
      <div class="bg-gray2 pt-2 pt-md-3 pb-0 pb-md-3 mb-2 mb-md-4">
         <div class="container-fluid">
            <div id="zone_musique_musique" data-testid="bande-musique" data-cache-key={cacheKey}>
               <div class="row">
                  <div class="col-12">
                     <h2>{title}</h2>
                  </div>
               </div>

               <div class="row o-musique">
                  <div
                     class="col-12 col-md-6 col-lg-4 o-musique-main lien-composite hover-dark order-1"
                     data-testid="musique1"
                     data-pdb-zid={item_portrait.analytics.pdbZid}
                     data-pdb-sc={item_portrait.analytics.pdbSc}
                     data-pdb-idc={item_portrait.analytics.pdbIdc}
                     data-pdb-vi={item_portrait.analytics.pdbVi}
                     data-oevent-category={item_portrait.analytics.oeventCategory}
                     data-oevent-action={item_portrait.analytics.oeventAction}
                     data-oevent-label={item_portrait.analytics.oeventLabel}
                     data-oevent-other={item_portrait.analytics.oeventOther}
                  >
                     <div class="row no-gutters">
                        <div class="pr-1 pt-1 col-7 col-md-12">
                           <div class="wrapper bg-white pb-1">
                              <picture>
                                 <source srcset={`${item_portrait.image}?format=425x425&saveas=webp`} media="(max-width: 959px)" />
                                 <source srcset={`${item_portrait.image}?format=335x335&saveas=webp`} media="(max-width: 1199px)" />
                                 <img loading="lazy" src={`${item_portrait.image}?format=405x405&saveas=webp`} alt={item_portrait.alt} class=" ml-1 mt--1 w-100" />
                              </picture>
                           </div>
                           <div class="wrapper bg-white px-1 pb-1 text-secondary">
                              <strong class="category text-gray3 d-block">{item_portrait.category}</strong>
                              <h3 class="lead font-weight-bold m-0 pt-0">
                                 <a class="title" href={item_portrait.URL} target={item_portrait.target} title={item_portrait.title}>
                                    {item_portrait.title}
                                 </a>
                              </h3>
                           </div>
                        </div>
                        <div class="col-5 col-md-12">
                           <p class="o-musique-description lead ml-1 my-1 text-gray3">{item_portrait.description}</p>
                        </div>
                     </div>
                  </div>
                  <div class="col-12 col-lg-4 order-2 order-md-3 order-lg-2 ">
                     <div class="row musique-slider">
                        {items_landscape.map(({ analytics, image, alt, category, URL, target, title }, index) => (
                           <div
                              class="col-3 col-lg-6 mb-2 d-flex flex-column lien-composite hover-dark"
                              data-testid={`musique${index + 2}`}
                              data-pdb-zid={analytics.pdbZid}
                              data-pdb-sc={analytics.pdbSc}
                              data-pdb-idc={analytics.pdbIdc}
                              data-pdb-vi={analytics.pdbVi}
                              data-oevent-category={analytics.oeventCategory}
                              data-oevent-action={analytics.oeventAction}
                              data-oevent-label={analytics.oeventLabel}
                              data-oevent-other={analytics.oeventOther}
                           >
                              <div class="vignette-musique d-flex flex-grow-1 flex-column">
                                 <div class="wrapper wrapper-image bg-white flex-shrink-0">
                                    <picture>
                                       <source srcset={`${image}?format=193x193&saveas=webp`} media="(max-width: 959px)" />
                                       <source srcset={`${image}?format=148x148&saveas=webp`} media="(max-width: 1199px)" />
                                       <img loading="lazy" src={`${image}?format=180x180&saveas=webp`} alt={alt} class="img w-100" />
                                    </picture>
                                 </div>
                                 <div class="wrapper wrapper-text bg-white text-secondary flex-grow-1 js-musique-thumb">
                                    <strong class="category text-gray3 d-block">{category}</strong>
                                    <h3 class="lead font-weight-bold m-0 pt-0">
                                       <a class="title" href={URL} target={target} title={title}>
                                          {title}
                                       </a>
                                    </h3>
                                 </div>
                              </div>
                           </div>
                        ))}
                     </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 order-3 order-md-2 order-lg-3 mb-0 mb-md-2 mb-lg-0">
                     {autopromo !== '' && autopromo.URL !== '' ? <Autopromo {...autopromo} /> : null}
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

const Autopromo = ({ URL, images, alt, analytics, cacheKey }) => {
   let cappingAdv
   if (analytics.pdbSc === 'adv') {
      cappingAdv = {
         'data-pdb-ta': analytics.pdbTa,
         'data-adv-canal': analytics.advCanal,
         'data-adv-cappingdata': analytics.advCappingdata,
      }
   }

   return (
      <div id="zone_musique_musique-push" data-testid="zone-push-musique" class="row h-100" data-cache-key={cacheKey}>
         <a
            href={URL}
            class="d-block o-musique-autopromo"
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
            {...cappingAdv}
         >
            <img src={`${isMobile() ? images.img2 : images.img1}?saveas=webp`} alt={alt} class="mw-100" loading="lazy" />
         </a>
      </div>
   )
}
